import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { TextButton, Button } from "@qgiv/core-donor";
import "./ResetPasswordEmailButton.scss";

const ResetPasswordEmailButton = ({
    displayNeedHelpWithPasswordButton,
    displaySendAnotherLinkButton,
}) => {
    const {
        ENUMS: { GlobalAccountAction },
    } = constants;
    const { setValues, submitForm, values } = useFormikContext();

    const handleNeedHelpClick = () => {
        const email = values.Email;
        const globalAccountAction =
            GlobalAccountAction.SEND_RESET_PASSWORD_EMAIL;
        const fields = {
            Password: "",
            PasswordConfirm: "",
            Unique_Identifier: "",
            Email: email,
            Global_Account_Action: globalAccountAction,
        };

        // Reset all of the field values other than the required email value
        setValues(fields);

        // Delay the form submission until the field value is set
        setTimeout(() => {
            submitForm();
        }, 0);
    };

    if (displayNeedHelpWithPasswordButton) {
        return (
            <div className="reset-password-email-button col col--12">
                <TextButton handleClick={handleNeedHelpClick}>
                    <strong>I need help with my password</strong>
                </TextButton>
            </div>
        );
    }

    if (displaySendAnotherLinkButton) {
        return (
            <div className="reset-password-email-button col col--12">
                <Button onClick={handleNeedHelpClick} type="button">
                    Send Another Link
                </Button>
            </div>
        );
    }

    return null;
};

ResetPasswordEmailButton.propTypes = {
    displayNeedHelpWithPasswordButton: PropTypes.bool.isRequired,
    displaySendAnotherLinkButton: PropTypes.bool.isRequired,
};

export default ResetPasswordEmailButton;
